export default function ContinerMain ({data, onDoubleClick, deleteAufaData}) {

    let flightsCars = data['data'];
    let flightFirst, flightLast;

    if ('fa' in flightsCars) {
        flightFirst = flightsCars['fa']['data'];
        flightLast = flightsCars['fr'] ? flightsCars['fr']['data'] : [];
    } else {
        flightFirst = flightsCars['fr'] ? flightsCars['fr']['data'] : [];
        flightLast = [];
    }

    let sum = 0;
    let flight = 0;
    let cars = 0;

    Object.keys(flightsCars).map((key) => {
        if (key.startsWith('f')) {
            flight ++;
        } else if (key.startsWith('c')) {
            cars ++;
        }
        sum += Number(flightsCars[key]['price']);
    })

    return (
        <div onClick={onDoubleClick} onContextMenu={deleteAufaData} className={"docketMainContinerFlightAufa"}>
            <p>אעופה</p>

            <div>
                {
                    flightFirst.length > 0 && flightFirst[4] && <p>תאריך ראשון:<span> {flightFirst[4]} </span></p>
                }
                {
                    flightFirst.length > 0 && flightFirst[6] && <p>פרטים: <span> {`${flightFirst[6]} - ${flightFirst[7]}`} </span></p>
                }
                {
                    flightLast.length > 0 && flightLast[4] && <p>תאריך אחרון : <span> {flightLast[4]} </span></p>
                }
                {
                    flightLast.length > 0 && flightLast[6] && <p>פרטים :<span> {`${flightLast[6]} - ${flightLast[7]}`} </span></p>
                }

                <p> מס' טיסות <span> {flight} </span> </p>
                <p> מס' נ"פ <span> {cars} </span> </p>
                <p>מס' נוסעים <span> {data['names'].length} </span></p>
            </div>

            <p>סה"כ <span> {sum}$ </span></p>
        </div>
    )
}